'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	AU: 'Австралія',
	AT: 'Австрія',
	AZ: 'Азербайджан',
	AX: 'Аландські',
	AL: 'Албанія',
	DZ: 'Алжир',
	AS: 'Американське',
	VI: 'Американські Віргінські',
	AI: 'Ангілья',
	AO: 'Ангола',
	AD: 'Андорра',
	AQ: 'Антарктида',
	AG: 'Антигуа і Барбуда',
	AR: 'Аргентина',
	AW: 'Аруба',
	AF: 'Афганістан',
	BS: 'Багамські',
	BD: 'Бангладеш',
	BB: 'Барбадос',
	BH: 'Бахрейн',
	BZ: 'Беліз',
	BE: 'Бельгія',
	BJ: 'Бенін',
	BM: 'Бермудські острови',
	BY: 'Білорусь',
	BG: 'Болгарія',
	BO: 'Болівія',
	BA: 'Боснія і Герцеговина',
	BW: 'Ботсвана',
	BR: 'Бразилія',
	IO: 'Британська територія в Індійському океані',
	VG: 'Британські Віргінські Острови',
	BN: 'Бруней',
	BF: 'Буркіна-Фасо',
	BI: 'Бурунді',
	BT: 'Бутан',
	VU: 'Вануату',
	VA: 'Ватикан',
	GB: 'Велика Британія',
	VE: 'Венесуела',
	VN: 'В\'єтнам',
	AM: 'Вірменія',
	WF: 'Волліс і Футунаі',
	GA: 'Габон',
	HT: 'Гаїті',
	GY: 'Гайана',
	GM: 'Гамбія',
	GH: 'Гана',
	GP: 'Гваделупа',
	GT: 'Гватемала',
	GN: 'Гвінея',
	GW: 'Гвінея-Бісау',
	GG: 'Гернсі',
	HN: 'Гондурас',
	HK: 'Гонконг',
	GD: 'Гренада',
	GR: 'Греція',
	GE: 'Грузія',
	GU: 'Гуам',
	GI: 'Гібралтар',
	GL: 'Ґренландія',
	DK: 'Данія',
	CD: 'ДР Конго',
	JE: 'Джерсі',
	DJ: 'Джибуті',
	DM: 'Домініка',
	DO: 'Домініканська Республіка',
	UM: 'Зовнішні малі острови США',
	EC: 'Еквадор',
	GQ: 'Екваторіальна Гвінея',
	ER: 'Еритрея',
	EE: 'Естонія',
	ET: 'Ефіопія',
	EG: 'Єгипет',
	YE: 'Ємен',
	ZM: 'Замбія',
	EH: 'Західна Сахара',
	ZW: 'Зімбабве',
	IL: 'Ізраїль',
	IN: 'Індія',
	ID: 'Індонезія',
	IQ: 'Ірак',
	IR: 'Іран',
	IE: 'Ірландія',
	IS: 'Ісландія',
	ES: 'Іспанія',
	IT: 'Італія',
	JO: 'Йорданія',
	CV: 'Кабо-Верде',
	KZ: 'Казахстан',
	KY: 'Кайманові острови',
	KH: 'Камбоджа',
	CM: 'Камерун',
	CA: 'Канада',
	QA: 'Катар',
	KE: 'Кенія',
	KG: 'Киргизстан',
	CN: 'КНР',
	KP: 'Північна Корея',
	CY: 'Кіпр',
	KI: 'Кірибаті',
	CC: 'Кокосові острови (Кілінг)',
	CO: 'Колумбія',
	KM: 'Коморські Острови Коморські',
	CG: 'Конго',
	CR: 'Коста-Рика',
	CI: 'Кот-д\'Івуар',
	CU: 'Куба',
	KW: 'Кувейт',
	CW: 'Кюрасао',
	LA: 'Лаос',
	LV: 'Латвія',
	LS: 'Лесото',
	LT: 'Литва',
	LR: 'Ліберія',
	LB: 'Ліван',
	LY: 'Лівія',
	LI: 'Ліхтенштейн',
	LU: 'Люксембург',
	MU: 'Маврикій',
	MR: 'Мавританія',
	MG: 'Мадагаскар',
	YT: 'Майотта',
	MO: 'Макао',
	MK: 'Македонія',
	MW: 'Малаві',
	MY: 'Малайзія',
	ML: 'Малі',
	MV: 'Мальдіви',
	MT: 'Мальта',
	MA: 'Марокко',
	MQ: 'Мартиніка',
	MH: 'Маршаллові Острови',
	MX: 'Мексика',
	MZ: 'Мозамбік',
	MD: 'Молдова',
	MC: 'Монако',
	MN: 'Монголія',
	MS: 'Монтсеррат',
	MM: 'М\'янма',
	NA: 'Намібія',
	NR: 'Науру',
	NP: 'Непал',
	NE: 'Нігер',
	NG: 'Нігерія',
	NL: 'Нідерланди',
	AN: 'Нідерландські Антильські острови',
	BQ: 'Карибські Нідерланди',
	NI: 'Нікарагуа',
	DE: 'Німеччина',
	NU: 'Ніуе',
	NZ: 'Нова Зеландія',
	NC: 'Нова Каледонія',
	NO: 'Норвегія',
	AE: 'ОАЕ',
	OM: 'Оман',
	BV: 'Острів Буве',
	IM: 'Острів Мен',
	NF: 'Острів Норфолк',
	CX: 'Острів Різдва',
	SH: 'Острови Святої Єлени, Вознесіння і Тристан-да-Кунья',
	HM: 'Острів Херд і острови Макдональд',
	CK: 'Острови Кука',
	PK: 'Пакистан',
	PW: 'Палау',
	PS: 'Палестинська держава',
	PA: 'Панама',
	PG: 'Папуа Нова Гвінея',
	PY: 'Парагвай',
	PE: 'Перу',
	GS: 'Південна Джорджія та Південні Сандвічеві острови',
	KR: 'Південна Корея',
	SS: 'Південний Судан',
	ZA: 'ПАР',
	MP: 'Північні Маріанські острови',
	PN: 'Піткерн',
	PL: 'Польща',
	PT: 'Португалія',
	PR: 'Пуерто-Рико',
	RE: 'Реюньйон',
	RU: 'Росія',
	RW: 'Руанда',
	RO: 'Румунія',
	SV: 'Сальвадор',
	WS: 'Самоа',
	SM: 'Сан-Марино',
	ST: 'Сан-Томе і Принсіпі',
	SA: 'Саудівська Аравія',
	SZ: 'Свазіленд',
	SJ: 'Свальбард і Ян-Маєн',
	SC: 'Сейшельські Острови',
	BL: 'Сен-Бартельмі',
	SN: 'Сенегал',
	MF: 'Сен-Мартен',
	PM: 'Сен-П\'єр і Мікелон',
	VC: 'Сент-Вінсент і Гренадини',
	KN: 'Сент-Кіттс і Невіс',
	LC: 'Сент-Люсія',
	RS: 'Сербія',
	SY: 'Сирія',
	SG: 'Сінгапур',
	SX: 'Сінт-Мартен',
	SK: 'Словаччина',
	SI: 'Словенія',
	SB: 'Соломонові Острови Соломонові',
	SO: 'Сомалі',
	US: 'США',
	SD: 'Судан',
	SR: 'Суринам',
	TL: 'Східний Тимор Східний',
	SL: 'Сьєрра-Леоне',
	TJ: 'Таджикистан',
	TH: 'Таїланд',
	TW: 'Тайвань',
	TZ: 'Танзанія',
	TC: 'Острови Теркс і Кайкос',
	TG: 'Того',
	TK: 'Токелау',
	TO: 'Тонга',
	TT: 'Тринідад і Тобаго',
	TV: 'Тувалу',
	TN: 'Туніс',
	TR: 'Туреччина',
	TM: 'Туркменістан',
	UG: 'Уганда',
	HU: 'Угорщина',
	UZ: 'Узбекистан',
	UA: 'Україна',
	UY: 'Уругвай',
	FO: 'Фарерські острови',
	FM: 'Федеративні Штати Мікронезії',
	FJ: 'Фіджі',
	PH: 'Філіппіни',
	FI: 'Фінляндія',
	FK: 'Фолклендські (Мальвінські) острови',
	FR: 'Франція',
	GF: 'Французька Гвіана Французька',
	PF: 'Французька Полінезія Французька',
	TF: 'Французькі Південні і Антарктичні території',
	HR: 'Хорватія',
	CF: 'Центральноафриканська Республіка',
	TD: 'Чад',
	CZ: 'Чехія',
	CL: 'Чилі',
	ME: 'Чорногорія',
	CH: 'Швейцарія',
	SE: 'Швеція',
	LK: 'Шрі-Ланка',
	JM: 'Ямайка',
	JP: 'Японія'
};


//////////////////
// WEBPACK FOOTER
// ./~/countries-3166/lib/translation/ua.js
// module id = 913
// module chunks = 1